<template>

<app-page>

	<core-content-page class="tipjar">

		<core-content-wrapper :loading="is.loading">

			<div class="head">

				<div class="head-about" v-if="!is.loading">

					<p>GeekGroup is <b>completely free and fully featured</b> to all BGG users and the goal is to keep developing and expanding it for many years to come.</p>
					
					<p>Help keep GeekGroup thriving and support continued development by becoming a Patreon. You'll even get some <b>awesome perks</b> as a thank you!</p>

					<core-button text="Become a Patreon" href="https://patreon.com/geekgroup" class="tipjar-button" icon="arrow-up-right-from-square" v-if="!isPatreon" />

					<core-button text="View Patreon" href="https://patreon.com/geekgroup" class="tipjar-button" icon="arrow-up-right-from-square" v-if="isPatreon" />

					<core-button text="Connect username with Patreon" v-on:click="onConnectClick" class="tipjar-button is-connect" icon="plug" v-if="!isPatreon" />

					<core-button text="Prefer Paypal? Contact me" href="mailto:phil@geekgroup.app" class="tipjar-button is-secondary" icon="envelope" v-if="!isPatreon" />

				</div>

				<com-personal v-if="!is.loading" />

				<com-overview :data="data" v-if="!is.loading" />

			</div>

			<com-tabs :tabs="tabs" :active="tab" v-on:change="onTabChange" v-if="!is.loading" />

			<core-content-page-inner class="tab-content" v-if="!is.loading">

				<template v-if="tab === 'perks'">

					<div class="tipjar-perks">

						<div class="tipjar-perks-item" :class="{'has-button': perks[perk].manage}" v-for="perk in perksEnabled" :key="perk">

							<i :class="perks[perk].icon"></i>

							<h2>{{ perks[perk].name }}</h2>

							<div class="tipjar-label" v-if="!isLegacy">{{ perks[perk].label }}</div>
							<div class="tipjar-label" v-if="isLegacy">Legacy Tipjar Perk</div>

							<p v-html="perks[perk].text" />

							<core-button text="Manage perk" theme="blue" v-if="perks[perk].manage" class="tipjar-perks-item-button" v-on:click="onPerkClick(perks[perk].manage)" />

						</div>

					</div>

				</template>

				<com-faq v-if="tab == 'faq'" />

				<template v-if="tab === 'all'">

					<div class="tipjar-perks">

						<div class="tipjar-perks-item" v-for="perk in perkOrder" :key="perk">

							<div class="tipjar-badge is-green" v-if="$_.contains(perksEnabled, perk)"><i class="fa fa-check" /></div>
							<div class="tipjar-badge is-red" v-if="!$_.contains(perksEnabled, perk)"><i class="fa fa-lock" /></div>

							<i :class="perks[perk].icon"></i>

							<h2>{{ perks[perk].name }}</h2>

							<div class="tipjar-label">{{ perks[perk].label }}</div>

							<p v-html="perks[perk].text" />

						</div>

					</div>

				</template>

				<template v-if="tab === 'why'">
				<div class="why">

					<p>GeekGroup is, and will always be, a completely free and fully featured website for everyone. If you’ve ever found out something new from your insights, discovered a group trend, or enjoyed sharing your collection, then that alone has made the years of development and maintenance worth it.</p>

					<p>By supporting on Patreon you’re helping keep GeekGroup sustainable and growing, while also getting access to a few thoughtful extras as thanks like faster profile loading and group sync tools.</p>

					<p>Support helps cover server costs and enables further development time, letting new ideas get built, tested, and released faster. It also means GeekGroup remains open to all, no matter how popular it gets!</p>

					<p>Whether you join for a month or stay long-term, every bit of support helps ensure GeekGroup can continue to flourish alongside your collection.</p>

					<p>Thank you for helping keep GeekGroup alive and awesome!</p>

					<p>Phil Carty,<br/>Developer</p>

				</div>
				</template>

			</core-content-page-inner>

		</core-content-wrapper>

	</core-content-page>
		
</app-page>

</template>

<script>

import Vue from 'vue'

import comTabs from './../profile/insights/common/Tabs'
import comPersonal from './patreon/Personal'
import comOverview from './patreon/Overview'
import comFaq from './patreon/Faq'

export default {

	components: {
		'com-tabs': comTabs,
		'com-faq': comFaq,
		'com-overview': comOverview,
		'com-personal': comPersonal
	},

	data: function() {
	
		return {

			tab: 'perks',

			data: {},

			is: {
				loading: true
			},

			perkOrder: [
				'dailysyncs',
				'manualsyncs',
				'discord',
				'featurevoting',
				'earlyaccess',
				'speedboosts',
				'subdomains',
				'externaldomains',
				'groupsyncs',
				'groupurl',
				'avatarbadge'
			],	

			perks: {
				discord: {
					icon: 'fa-brands fa-discord',
					name: 'Discord Server',
					label: 'All Patreons',
					text: 'You are invited to our <b>discord community</b> where you can suggest features, report bugs, and chat with fellow patreons.'
				},
				featurevoting: {
					icon: 'fa fa-check-to-slot',
					name: 'Feature Voting',
					label: 'All Patreons',
					text: 'You get to <b>choose which features</b> you want to be added next in a monthly vote.',
					manage: 'SessionPatreonVoting'
				},
				dailysyncs: {
					icon: 'fa fa-calendar-alt',
					name: 'Daily Automated Syncs',
					label: 'All Patreons',
					text: 'Your profile will <b>automatically sync every day</b>, instead of every week.'
				},
				manualsyncs: {
					icon: 'fa fa-sync-alt',
					name: 'Unlimited Manual Syncs',
					label: 'All Patreons',
					text: 'You can <b>manually re-sync</b> your data anytime by clicking the run sync button, including deep syncs for private data.'
				},
				groupsyncs: {
					icon: 'fa fa-users',
					name: 'Daily Group Syncs',
					label: 'Group Leaders',
					text: 'Have your <b>group data</b> sync daily even if members aren\'t Patreons (max 25 users).',
					manage: 'SessionPatreonSyncs'
				},
				subdomains: {
					icon: 'fa fa-globe-pointer',
					name: 'Custom Subdomains',
					label: 'Power Users & Group Leaders',
					text: 'Have a <b>unique subdomain</b> for your profile or a group (e.g. username.geekgroup.app).',
					manage: 'SessionPatreonSubdomains'
				},
				externaldomains: {
					icon: 'fa fa-solid fa-arrow-up-right-from-square',
					name: 'External Domains',
					label: 'Power Users & Group Leaders',
					text: 'Use <b>your own domain</b> for your profile or a group (e.g. yourdomain.com or games.yourdomain.com).',
					manage: 'SessionPatreonExternaldomains'
				},
				speedboosts: {
					icon: 'fa fa-gauge-max',
					name: 'Speed Boosts',
					label: 'Power Users & Group Leaders',
					text: 'Get <b>faster loading</b> for your own profile or a nominated group with a priority database.',
					manage: 'SessionPatreonBoosts'
				},
				earlyaccess: {
					icon: 'fa fa-flask',
					name: 'Early Access',
					label: 'Power Users & Group Leaders',
					text: 'Be the first to get <b>exclusive access</b> to new features and tools.',
					manage: 'SessionPatreonAccess'
				},
				groupurl: {
					icon: 'fa fa-pencil-alt',
					name: 'Group URLs',
					label: 'All Patreons',
					text: 'You can give your group a <b>custom URL</b> instead of a randomly assigned one.'
				},
				avatarbadge: {
					icon: 'fa fa-badge-check',
					name: 'Avatar Badge',
					label: 'All Patreons',
					text: 'Have a special Patreon badge added next your avatar and name.'
				}
			}

		}
	
	},

	created: function() {

		if(!this.hasUpgraded) this.tab = 'all'

        this.load()

	},

	computed: {

		perksEnabled: function() {

			return this.$_.filter(this.perkOrder, function(perk) {

				return this.$store.getters['session/user/perks'][perk] || perk === 'discord'

			}.bind(this))

		},

		tabs: function() {

			var tabs = []

			if (this.hasUpgraded) {

				tabs = [
					{ value: 'perks', text: 'Your Perks' },
					{ value: 'all', text: 'All Perks', count: this.perkOrder.length },
					{ value: 'why', text: (this.window.is.mobile) ? 'Why?' : 'Why Support?' },
					{ value: 'faq', text: (this.window.is.mobile) ? 'FAQ' : 'FAQ' },
				]

			} else {

				tabs = [
					{ value: 'all', text: 'Perks', count: 11 },
					{ value: 'why', text: 'Why support?' },
					{ value: 'faq', text: (this.window.is.mobile) ? 'FAQ' : 'FAQ' },
				]

			}

			return tabs

		},

		isLegacy: function() {

			return this.$store.getters['session/upgraded'] === 1

		},

		isPatreon: function() {

			return this.$store.getters['session/upgraded'] > 1

		},

		hasUpgraded: function() {

			return this.$store.getters['session/upgraded']

		}

	},

	methods: {

		onConnectClick: function() {

			this.$pubsub.$emit('open.modal', 'sessionPatreonConnect')

		},

		onPerkClick: function(name) {

			this.$routerPush({
				name: name
			})

		},
    
        load: function() {
        
            this.$api.get('session/patreon').then(function(json) {

				Vue.set(this, 'data', json)

                this.is.loading = false

				if(this.$route.query.state) {

					this.$pubsub.$emit('open.modal', 'sessionPatreonConnect')

				}
            
            }.bind(this))
        
        },

		onTabChange: function(value) {

			this.tab = value

		}

	}

}

</script>

<style scoped>

.head {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	margin-bottom: 40px;
	grid-gap: 20px;
}

.is-tablet .head {
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
	grid-gap: 20px;
}

.is-mobile .head {
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
	grid-gap: 20px;
}

.head-about {
	background-color: #fff;
	border: 1px solid #ddd;
	padding: 15px;
	border-radius: 4px;
}

.head-about >>> p {
	margin-bottom: 15px!important;
}

.is-tablet .head-about {
	grid-column: span 6;
}

.is-mobile .head-about {
	grid-column: span 6;
	padding: 10px 0px 0px 0px;
	border: 0px;
}

.tab-content {
	padding-top: 40px!important;
}

.is-mobile .tab-content {
	padding-top: 20px!important;
}

.is-mobile .tabs {
	padding: 0px 0px;
}

.is-desktop .tab-content:before {
    position: absolute;
    content: '';
    display: block;
    left: -40px;
	right: -40px;
	top: 0px;
	bottom: -40px;
	background-color: #fff;
}

.box {
	border-radius: 4px;
	margin-bottom: 20px;
	border: 1px solid #ddd;
	background-color: #fff;
	padding: 20px;
}

.is-mobile .box {
	margin-bottom: 20px;
	padding: 10px;
}

.box.is-green {
	background-color: #7beb92;
}

.tipjar >>> p {
    font-size: 16px!important;
    opacity: 0.75;
    line-height: 20px;
    text-align: left;
	margin-bottom: 20px;
}

.tipjar >>> p:last-child {
	margin-bottom: 0px;
}

.tipjar-button {
	line-height: 40px;
	font-weight: 700;
	display: flex!important;
	text-align: left!important;
	background-color: #082534!important;
}

.tipjar-button.is-connect {
	background-color: #48bb6a!important;
	margin-top: 5px;
}

.tipjar-button.is-secondary {
	background-color: #4881bb!important;
	margin-top: 5px;
}

.tipjar-title {
	font-size: 24px;
	color: #4881bb;
	margin-bottom: 20px;
	text-align: center;
	font-weight: 700;
	
}

.tipjar-title small {
	font-size: 15px;
	color: #666;
	display: block;
	font-weight: 400;
	margin-top: 5px;
}

.tipjar-perks {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	list-style: none!important;
	grid-gap: 20px;
	margin-bottom: 20px;
}

.is-mobile .tipjar-perks {
	grid-template-columns: 1fr;
	grid-gap: 0px;
	padding: 0px;
}

.tipjar-perks-item {
	border: 1px solid #ddd;
	border-radius: 4px;
    padding: 20px 20px 20px 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
    background-color: #fff;
}

.is-mobile .tipjar-perks-item {
    border: 0px;
	border-radius: 0px;
	border-bottom: 1px solid #ddd;
    padding: 20px 10px 20px 10px;
}

.is-mobile .tipjar-perks-item:last-child {
	border-bottom: 0px;
}

.tipjar-perks-item.has-button {
	padding-bottom: 70px;
}

.tipjar-perks-item > .fa,
.tipjar-perks-item > .fa-brands {
	font-size: 64px;
	color: #4881bb;
	display: block;
	height: 64px;
	margin-bottom: 20px;
}

.is-mobile .tipjar-perks-item > .fa,
.is-mobile .tipjar-perks-item > .fa-brands {
	font-size: 48px;
	height: 48px;
}

.tipjar-perks-item h2 {
	font-size: 20px;
	display: block;
	margin-bottom: 6px;
}

.tipjar-perks-item p {
	font-size: 16px;
	display: block;
	color: #222;
	margin-bottom: 4px;
	text-align: center;
}

.tipjar-perks-item-button {
	width: 100%;
	position: absolute;
	left: 20px;
	bottom: 20px;
	width: calc(100% - 40px);
}

.tipjar-label {
	border-radius: 4px;
	padding: 4px 8px;
	background-color: #bbd4ee;
	font-size: 12px;
	color: #19455c;
	font-weight: 400;
	margin-bottom: 10px;
	margin-top: -2px;
}

.tipjar-badge {
	position: absolute;
	right: -6px;
	top: -6px;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	color: #fff;
	font-size: 20px;
	line-height: 40px;
	text-align: center;
}

.is-mobile .tipjar-badge {
	right: 10px;
	top: 10px;
}

.tipjar-badge.is-green {
	background-color: #4eb34e;
}

.tipjar-badge.is-red {
	background-color: #b94d4d;
	font-size: 18px;
}

.why {
	padding: 20px;
	border: 1px solid #eee;
	border-radius: 10px;
	font-size: 16px;
	line-height: 20px;
}

.is-mobile .why {
	border: 0px;
	padding: 0px 10px;
}

</style>